
import { Component, Vue } from 'vue-property-decorator'

/**
 * Cookie情報取得処理を共通化するMixinコンポーネント
 */
@Component
export default class CookieMethods extends Vue {
  protected get authAcbt() {
    return Vue.prototype.$cookies.get('authAcbt')
  }

  protected async resetAuthAcbt() {
    await Vue.prototype.$cookies.remove('authAcbt')
  }

  // 認証トークン存在チェック
  protected get isTokensExist(): boolean {
    const auth = this.authAcbt
    return auth && auth.accessToken && auth.client && auth.uid && auth.currentApiUserRole
  }

  // ログインユーザID
  protected get currentUserId() {
    return this.authAcbt.currentApiUserId
  }

  // ログインユーザUID
  protected get currentUserUid() {
    return this.authAcbt.uid
  }

  // ログインユーザ権限
  protected get currentUserRole() {
    return this.authAcbt.currentApiUserRole
  }

  // ログインユーザ名
  protected get currentUserName() {
    return this.authAcbt.currentApiUserName
  }

  // 教室ID
  protected get currentBranchId() {
    return this.authAcbt.currentApiBranchId
  }

  // 教室名
  protected get currentBranchName() {
    return this.authAcbt.currentApiBranchName
  }

  // 塾ID
  protected get currentAcademyId() {
    return this.authAcbt.currentApiAcademyId
  }

  // 塾名
  protected get currentAcademyName() {
    return this.authAcbt.currentApiAcademyName
  }

  // 学年
  protected get currentGradeName() {
    return this.authAcbt.currentApiGradeName
  }
}
